import { Injectable } from '@angular/core';
import { EEvent } from './Events';


export interface TPostMessage {
    name: EEvent;
    data?: any;
}

@Injectable({
    providedIn: 'root'
})
export class ParentWindowService {

    constructor() { }

    public postMessage(message: TPostMessage): void {
        if (this.isInIframe && window && window.parent && window.parent.postMessage) {
            window.parent.postMessage(JSON.stringify(message), '*');
        } else {
            console.log('No parent window');
        }
    }

    get isInIframe(): boolean {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }

    public get url(): string {
        if (this.isInIframe) {
            const urlArr = document.referrer.split('/');
            return urlArr[0] + '//' + urlArr[2];
        } else {
            // eslint-disable-next-line @typescript-eslint/dot-notation
            return window['parentUrl'];
        }
    }

    public get fullUrl(): string {
        if (this.isInIframe) {
            return document.referrer;
        }
    }

}
